<template>
  <div>
    <div class="search">
      <Input search enter-button v-model="keyword"  placeholder="Enter something..." style="width: 300px" on-search="hhah" on-enter="xixi"/>
    </div>
    <div class="search-content" ref ="search"  v-show="keyword">
      <ul>
        <li>
          1232
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Bscroll from 'better-scroll'
export default {
  data(){
    return{
      keyword:'',
      list:[]
    }
  },
  wathch:{
    keyword(){
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (!this.keyword) {
        this.list = []
        return
      }
      this.timer = setTimeout(() => {
        const result = []
        for (let i in this.cities) {
          // this.cities[i].forEach((value) => {
          //   if (value.spell.indexOf(this.keyword) > -1 || value.name.indexOf(this.keyword) > -1) {
          //     result.push(value)
          //   }
          // })
        }
       // this.list = result
      }, 100)
    }
  },
  methods:{
    hhah(){
      console.log("54654")
    },
  },
   mounted () {
    this.scroll = new Bscroll(this.$refs.search)
  }
}
</script>
<style>
  .search{
    margin-top: 0.2rem;
    padding-left: 0.2rem;
  }
 .search-content{
   z-index: 1;
    overflow: hidden;
    position: absolute;
    top: 1rem;
    left: 0;
    right: 0;;
    bottom: 0;
    background: white;
}
   
</style>








// WEBPACK FOOTER //
// src/components/content/userlist/Search.vue